/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  CreateRewardConfigRequestBody,
  DistributeRewardRequest,
  DistributedRewardResponse,
  GetDistributedRewardsOwnResponse,
  GetRewardConfigsResponse,
  ManualDistributeRewardResponse,
  RewardConfigResponse,
  RewardFulfillmentClaimBody,
  RewardFulfillmentClaimResponse,
  UpdateRewardConfigRequestBody,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CreateRewardConfigRequestBodyFromJSON,
    CreateRewardConfigRequestBodyToJSON,
    DistributeRewardRequestFromJSON,
    DistributeRewardRequestToJSON,
    DistributedRewardResponseFromJSON,
    DistributedRewardResponseToJSON,
    GetDistributedRewardsOwnResponseFromJSON,
    GetDistributedRewardsOwnResponseToJSON,
    GetRewardConfigsResponseFromJSON,
    GetRewardConfigsResponseToJSON,
    ManualDistributeRewardResponseFromJSON,
    ManualDistributeRewardResponseToJSON,
    RewardConfigResponseFromJSON,
    RewardConfigResponseToJSON,
    RewardFulfillmentClaimBodyFromJSON,
    RewardFulfillmentClaimBodyToJSON,
    RewardFulfillmentClaimResponseFromJSON,
    RewardFulfillmentClaimResponseToJSON,
    UpdateRewardConfigRequestBodyFromJSON,
    UpdateRewardConfigRequestBodyToJSON,
} from '../models/index';

export interface CreateRewardsRequest {
    createRewardConfigRequestBody?: CreateRewardConfigRequestBody;
}

export interface CreateRewardsDistributeRequest {
    distributeRewardRequest?: DistributeRewardRequest;
}

export interface CreateRewardsFulfillmentClaimRequest {
    rewardFulfillmentClaimBody: RewardFulfillmentClaimBody;
}

export interface GetDistributedRewardsIdSingleRequest {
    id: string;
}

export interface GetDistributedRewardsOwnRequest {
    subject?: string;
    webNotificationDismissed?: boolean;
    devourPlayNotificationDismissed?: boolean;
}

export interface GetRewardConfigsRequest {
    search?: string;
    ids?: Array<string>;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface UpdateDistributedRewardsIdDismissNotificationDevourPlayRequest {
    id: string;
    body?: object;
}

export interface UpdateDistributedRewardsIdDismissNotificationWebRequest {
    id: string;
}

export interface UpdateRewardsIdRequest {
    id: string;
    updateRewardConfigRequestBody?: UpdateRewardConfigRequestBody;
}

/**
 * RewardsApi - interface
 * 
 * @export
 * @interface RewardsApiInterface
 */
export interface RewardsApiInterface {
    /**
     * Used to create new Overwolf quest (OWReward doc)
     * @param {CreateRewardConfigRequestBody} [createRewardConfigRequestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApiInterface
     */
    createRewardsRaw(requestParameters: CreateRewardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardConfigResponse>>;

    /**
     * Used to create new Overwolf quest (OWReward doc)
     */
    createRewards(requestParameters: CreateRewardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardConfigResponse>;

    /**
     * Used by admins to manually distribute rewards
     * @param {DistributeRewardRequest} [distributeRewardRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApiInterface
     */
    createRewardsDistributeRaw(requestParameters: CreateRewardsDistributeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ManualDistributeRewardResponse>>;

    /**
     * Used by admins to manually distribute rewards
     */
    createRewardsDistribute(requestParameters: CreateRewardsDistributeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ManualDistributeRewardResponse>;

    /**
     * Inline form replacement for the legacy claimFormUrl Google Form pattern. Only valid for MERCH-type or manual GIFT_CARD (no tilloProductId) rewards. Fires ops email + Slack notifications on commit.
     * @summary Submit shipping info to claim a physical-ship reward
     * @param {RewardFulfillmentClaimBody} rewardFulfillmentClaimBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApiInterface
     */
    createRewardsFulfillmentClaimRaw(requestParameters: CreateRewardsFulfillmentClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardFulfillmentClaimResponse>>;

    /**
     * Inline form replacement for the legacy claimFormUrl Google Form pattern. Only valid for MERCH-type or manual GIFT_CARD (no tilloProductId) rewards. Fires ops email + Slack notifications on commit.
     * Submit shipping info to claim a physical-ship reward
     */
    createRewardsFulfillmentClaim(requestParameters: CreateRewardsFulfillmentClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardFulfillmentClaimResponse>;

    /**
     * Retrieves a single distributed reward data.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApiInterface
     */
    getDistributedRewardsIdSingleRaw(requestParameters: GetDistributedRewardsIdSingleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DistributedRewardResponse>>;

    /**
     * Retrieves a single distributed reward data.
     */
    getDistributedRewardsIdSingle(requestParameters: GetDistributedRewardsIdSingleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DistributedRewardResponse>;

    /**
     * Used by user to get a list of all their distributed rewards
     * @param {string} [subject] 
     * @param {boolean} [webNotificationDismissed] 
     * @param {boolean} [devourPlayNotificationDismissed] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApiInterface
     */
    getDistributedRewardsOwnRaw(requestParameters: GetDistributedRewardsOwnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDistributedRewardsOwnResponse>>;

    /**
     * Used by user to get a list of all their distributed rewards
     */
    getDistributedRewardsOwn(requestParameters: GetDistributedRewardsOwnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDistributedRewardsOwnResponse>;

    /**
     * Used by admin to get a list of all reward configs
     * @param {string} [search] 
     * @param {Array<string>} [ids] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApiInterface
     */
    getRewardConfigsRaw(requestParameters: GetRewardConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetRewardConfigsResponse>>;

    /**
     * Used by admin to get a list of all reward configs
     */
    getRewardConfigs(requestParameters: GetRewardConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetRewardConfigsResponse>;

    /**
     * Used to dismiss a distributed reward notification
     * @param {string} id 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApiInterface
     */
    updateDistributedRewardsIdDismissNotificationDevourPlayRaw(requestParameters: UpdateDistributedRewardsIdDismissNotificationDevourPlayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DistributedRewardResponse>>;

    /**
     * Used to dismiss a distributed reward notification
     */
    updateDistributedRewardsIdDismissNotificationDevourPlay(requestParameters: UpdateDistributedRewardsIdDismissNotificationDevourPlayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DistributedRewardResponse>;

    /**
     * Used to dismiss a distributed reward notification
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApiInterface
     */
    updateDistributedRewardsIdDismissNotificationWebRaw(requestParameters: UpdateDistributedRewardsIdDismissNotificationWebRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DistributedRewardResponse>>;

    /**
     * Used to dismiss a distributed reward notification
     */
    updateDistributedRewardsIdDismissNotificationWeb(requestParameters: UpdateDistributedRewardsIdDismissNotificationWebRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DistributedRewardResponse>;

    /**
     * Used to update existing Overwolf game
     * @param {string} id 
     * @param {UpdateRewardConfigRequestBody} [updateRewardConfigRequestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApiInterface
     */
    updateRewardsIdRaw(requestParameters: UpdateRewardsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardConfigResponse>>;

    /**
     * Used to update existing Overwolf game
     */
    updateRewardsId(requestParameters: UpdateRewardsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardConfigResponse>;

}

/**
 * 
 */
export class RewardsApi extends runtime.BaseAPI implements RewardsApiInterface {

    /**
     * Used to create new Overwolf quest (OWReward doc)
     */
    async createRewardsRaw(requestParameters: CreateRewardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardConfigResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/rewards`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateRewardConfigRequestBodyToJSON(requestParameters['createRewardConfigRequestBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardConfigResponseFromJSON(jsonValue));
    }

    /**
     * Used to create new Overwolf quest (OWReward doc)
     */
    async createRewards(requestParameters: CreateRewardsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardConfigResponse> {
        const response = await this.createRewardsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by admins to manually distribute rewards
     */
    async createRewardsDistributeRaw(requestParameters: CreateRewardsDistributeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ManualDistributeRewardResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/rewards/distribute`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DistributeRewardRequestToJSON(requestParameters['distributeRewardRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ManualDistributeRewardResponseFromJSON(jsonValue));
    }

    /**
     * Used by admins to manually distribute rewards
     */
    async createRewardsDistribute(requestParameters: CreateRewardsDistributeRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ManualDistributeRewardResponse> {
        const response = await this.createRewardsDistributeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Inline form replacement for the legacy claimFormUrl Google Form pattern. Only valid for MERCH-type or manual GIFT_CARD (no tilloProductId) rewards. Fires ops email + Slack notifications on commit.
     * Submit shipping info to claim a physical-ship reward
     */
    async createRewardsFulfillmentClaimRaw(requestParameters: CreateRewardsFulfillmentClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardFulfillmentClaimResponse>> {
        if (requestParameters['rewardFulfillmentClaimBody'] == null) {
            throw new runtime.RequiredError(
                'rewardFulfillmentClaimBody',
                'Required parameter "rewardFulfillmentClaimBody" was null or undefined when calling createRewardsFulfillmentClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/rewards/fulfillment-claim`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RewardFulfillmentClaimBodyToJSON(requestParameters['rewardFulfillmentClaimBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardFulfillmentClaimResponseFromJSON(jsonValue));
    }

    /**
     * Inline form replacement for the legacy claimFormUrl Google Form pattern. Only valid for MERCH-type or manual GIFT_CARD (no tilloProductId) rewards. Fires ops email + Slack notifications on commit.
     * Submit shipping info to claim a physical-ship reward
     */
    async createRewardsFulfillmentClaim(requestParameters: CreateRewardsFulfillmentClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardFulfillmentClaimResponse> {
        const response = await this.createRewardsFulfillmentClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a single distributed reward data.
     */
    async getDistributedRewardsIdSingleRaw(requestParameters: GetDistributedRewardsIdSingleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DistributedRewardResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getDistributedRewardsIdSingle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/distributed-rewards/{id}/single`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DistributedRewardResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a single distributed reward data.
     */
    async getDistributedRewardsIdSingle(requestParameters: GetDistributedRewardsIdSingleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DistributedRewardResponse> {
        const response = await this.getDistributedRewardsIdSingleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by user to get a list of all their distributed rewards
     */
    async getDistributedRewardsOwnRaw(requestParameters: GetDistributedRewardsOwnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDistributedRewardsOwnResponse>> {
        const queryParameters: any = {};

        if (requestParameters['subject'] != null) {
            queryParameters['subject'] = requestParameters['subject'];
        }

        if (requestParameters['webNotificationDismissed'] != null) {
            queryParameters['webNotificationDismissed'] = requestParameters['webNotificationDismissed'];
        }

        if (requestParameters['devourPlayNotificationDismissed'] != null) {
            queryParameters['devourPlayNotificationDismissed'] = requestParameters['devourPlayNotificationDismissed'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/distributed-rewards/own`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDistributedRewardsOwnResponseFromJSON(jsonValue));
    }

    /**
     * Used by user to get a list of all their distributed rewards
     */
    async getDistributedRewardsOwn(requestParameters: GetDistributedRewardsOwnRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDistributedRewardsOwnResponse> {
        const response = await this.getDistributedRewardsOwnRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by admin to get a list of all reward configs
     */
    async getRewardConfigsRaw(requestParameters: GetRewardConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetRewardConfigsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reward-configs`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRewardConfigsResponseFromJSON(jsonValue));
    }

    /**
     * Used by admin to get a list of all reward configs
     */
    async getRewardConfigs(requestParameters: GetRewardConfigsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetRewardConfigsResponse> {
        const response = await this.getRewardConfigsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to dismiss a distributed reward notification
     */
    async updateDistributedRewardsIdDismissNotificationDevourPlayRaw(requestParameters: UpdateDistributedRewardsIdDismissNotificationDevourPlayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DistributedRewardResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateDistributedRewardsIdDismissNotificationDevourPlay().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/distributed-rewards/{id}/dismiss-notification-devour-play`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DistributedRewardResponseFromJSON(jsonValue));
    }

    /**
     * Used to dismiss a distributed reward notification
     */
    async updateDistributedRewardsIdDismissNotificationDevourPlay(requestParameters: UpdateDistributedRewardsIdDismissNotificationDevourPlayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DistributedRewardResponse> {
        const response = await this.updateDistributedRewardsIdDismissNotificationDevourPlayRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to dismiss a distributed reward notification
     */
    async updateDistributedRewardsIdDismissNotificationWebRaw(requestParameters: UpdateDistributedRewardsIdDismissNotificationWebRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DistributedRewardResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateDistributedRewardsIdDismissNotificationWeb().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/distributed-rewards/{id}/dismiss-notification-web`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DistributedRewardResponseFromJSON(jsonValue));
    }

    /**
     * Used to dismiss a distributed reward notification
     */
    async updateDistributedRewardsIdDismissNotificationWeb(requestParameters: UpdateDistributedRewardsIdDismissNotificationWebRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DistributedRewardResponse> {
        const response = await this.updateDistributedRewardsIdDismissNotificationWebRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to update existing Overwolf game
     */
    async updateRewardsIdRaw(requestParameters: UpdateRewardsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RewardConfigResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateRewardsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/rewards/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateRewardConfigRequestBodyToJSON(requestParameters['updateRewardConfigRequestBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RewardConfigResponseFromJSON(jsonValue));
    }

    /**
     * Used to update existing Overwolf game
     */
    async updateRewardsId(requestParameters: UpdateRewardsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RewardConfigResponse> {
        const response = await this.updateRewardsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
